import gsap from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollToPlugin);
gsap.defaults({
  duration: 0.2,
  ease: 'power3.out',
});

export default function refinement(renderOptions, isFirstRender) {
  const { items, refine, createURL, widgetParams } = renderOptions;
  const { filtersManager, attribute } = widgetParams;

  const container = document.querySelector(widgetParams.container);
  const searchContainer = document.querySelector('.js-search');

  if (isFirstRender) {
    const refinementUl = document.createElement('ul');
    refinementUl.classList.add('search-refinement__list', 'js-filters');

    container.appendChild(refinementUl);
  }

  container.querySelector('ul').innerHTML = items
    .map(
      item => `
        <li class="search-refinement__list-item">
          <a
            href="${createURL(item.value)}"
            class="${
  item.isRefined
    ? 'search-refinement__list-item-link-selected'
    : 'search-refinement__list-item-link'
}"
            data-value="${item.value}"
          >
            ${item.label} <span class="search-refinement__list-item-count">${item.count}</span>
          </a>
        </li>
      `,
    )
    .join('');

  filtersManager.setFilters(
    attribute,
    items.filter(({ isRefined }) => isRefined),
    refine,
  );

  [...container.querySelectorAll('a')].forEach(element => {
    element.addEventListener('click', e => {
      e.preventDefault();
      refine(e.currentTarget.dataset.value);
      const searchTop = searchContainer.getBoundingClientRect().top;
      if (window.innerWidth >= 1200) {
        if (searchTop < 0) {
          gsap.set(window, { scrollTo: window.scrollY + searchTop });
        }
      }
    });
  });

  const refinementList = document.querySelector('.js-refinement-wrapper');

  items.length === 0
    ? refinementList.classList.add('is-empty')
    : refinementList.classList.remove('is-empty');

  document
    .querySelector('.search-filters__list')
    .classList.toggle('filter-list-is-visible', filtersManager.isVisible());
}
